var makeString = require('./helper/makeString');

module.exports = function decapitalize(str) {
  str = makeString(str);
  return str.charAt(0).toLowerCase() + str.slice(1);
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/decapitalize.js
 ** module id = 394
 ** module chunks = 0
 **/